import React from "react";
import { Typography } from "@mui/material";
import themestyle from "../theme";


export const textFieldSX = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    minHeight: { xs: "38px", sm: "44px" },

    "& input": {
      fontSize: { xs: "11px", sm: "14px" },
      padding: { xs: "12px", sm: "10px 12px" },
      fontFamily: themestyle.fontFamily.Roboto,
    },

    "& textarea": {
      fontSize: { xs: "12px", sm: "14px" },
      padding: "12px",
      fontFamily: themestyle.fontFamily.Roboto,
    },

    "&.Mui-focused fieldset": {
      borderColor: themestyle.colors.activeGreen,
      borderWidth: "1px",
    },
  },

  "& .MuiAutocomplete-inputRoot": {
    paddingLeft: "22px",
    minHeight: { xs: "38px", sm: "44px" },
    alignItems: "center",
  },

  "& .MuiAutocomplete-input": {
    padding: "0 !important",
    fontSize: { xs: "11px", sm: "14px" },
    fontFamily: themestyle.fontFamily.Roboto,
  },

  "& .MuiAutocomplete-endAdornment": {
    top: "50%",
    transform: "translateY(-50%)",
  },

  "& .MuiAutocomplete-option": {
    fontSize: { xs: "12px", sm: "10px" },
    fontFamily: themestyle.fontFamily.Roboto,
    padding: "8px 12px",
  },
   "& .MuiFormHelperText-root": {
    fontSize: { xs: "10px", sm: "12px" },
    marginLeft: "0px",
    marginTop: "0px",
    fontFamily: themestyle.fontFamily.Roboto,
  },
};

// MUI X date/time pickers render their own input root (`.MuiPickersInputBase-root`), not
// `.MuiOutlinedInput-root`, so textFieldSX's height/font never reaches them. This re-applies
// the same 38/44px height and font used by the other form fields (Class Name, Select Class…)
// so the picker boxes are visually identical.
export const pickerFieldSX = {
  ...textFieldSX,
  "& .MuiPickersInputBase-root": {
    borderRadius: "8px",
    minHeight: { xs: "38px", sm: "44px" },
    fontSize: { xs: "11px", sm: "14px" },
    fontFamily: themestyle.fontFamily.Roboto,
  },
  "& .MuiPickersInputBase-sectionsContainer": {
    padding: { xs: "12px", sm: "10px 12px" },
  },
  // Match the other form fields: green focus border (pickers use their own outline class,
  // so textFieldSX's Mui-focused rule doesn't reach them).
  "& .MuiPickersOutlinedInput-root:hover .MuiPickersOutlinedInput-notchedOutline": {
    borderColor: themestyle.colors.activeGreen,
  },
  "& .MuiPickersOutlinedInput-root.Mui-focused .MuiPickersOutlinedInput-notchedOutline": {
    borderColor: themestyle.colors.activeGreen,
    borderWidth: "1px",
  },
};

export type FormLabelProps = {
  children: React.ReactNode;
};

export const FormLabel: React.FC<FormLabelProps> = ({ children }) => {
  let text = '';
  let childrenArray: React.ReactNode[] = [];
  if (typeof children === 'string') {
    text = children;
  } else if (Array.isArray(children)) {
    text = children.join('');
    childrenArray = children;
  } else if (children) {
    text = String(children);
  }
  const hasAsterisk = text.includes('*');
  if (hasAsterisk) {
    const labelText = text.split('*')[0];
    return (
      <Typography
        mb={1}
        sx={{
          fontSize: { xs: "13px", sm: "14px", md: "16px" },
          fontWeight: 500,
          fontFamily: themestyle.fontFamily.Roboto,
          color: themestyle.colors.black,
        }}
      >
        {labelText}
        <span style={{ color: 'red' }}>*</span>
      </Typography>
    );
  }
  return (
    <Typography
      mb={1}
      sx={{
        fontSize: { xs: "13px", sm: "14px", md: "16px" },
        fontWeight: 500,
        fontFamily: themestyle.fontFamily.Roboto,
        color: themestyle.colors.black,
      }}
    >
      {children}
    </Typography>
  );
};

export const autocompleteListboxSX = {
  maxHeight: "180px",
  overflowY: "auto",
  "& .MuiAutocomplete-option": {
    fontSize: { xs: "12px", sm: "14px" },
    padding: { xs: "6px 12px", sm: "10px 16px" },
    minHeight: { xs: "32px", sm: "40px" },
    alignItems: "center",
  },
};